// extracted by mini-css-extract-plugin
export default {"about":"about_about__HPAah","section-one":"about_section-one__2DNSL","info":"about_info__tiHRU","btn":"about_btn__PjIil","img":"about_img__W4eQT"};